import {
  lazy,
  LazyLoadComponent,
} from "mhc-ui-components/dist/LazyLoadComponent";

import {EUserAuthenticationRights} from "mhc-server/dist/interfaces";

import {IAppRoute} from "../../application/config/IAppRoute";

const UserCRUDPage = lazy(() => import("../pages/UserCRUDPage/UserCRUDPage"));

export const routeUserEdit: IAppRoute<{
  userId: string;
}> = {
  menuId: '',
  title: 'Edit User',
  routePath: '/user-management/edit/:userId',
  getRoutePath: ({userId} = {userId: ''}) =>
    routeUserEdit.routePath
      .replace(':userId', userId),
  userHasAllRights: [],
  userHasAnyOfRights: [
    EUserAuthenticationRights.ADMINISTRATOR,
    EUserAuthenticationRights.SYSTEM_ADMINISTRATOR,
  ],
  exact: true,
  render: ({pathParams: {userId}}) => (
    <LazyLoadComponent>
      <UserCRUDPage userId={userId}/>
    </LazyLoadComponent>
  ),
};
